import { Button, showConfirmationPrompt } from '@bpinternal/ui-kit-next'
import { Trash } from 'lucide-react'
import { useDeleteKnowledgeSources } from '~/features/knowledge-bases/hooks/useKnowledgeSource'

type KnowledgeSourceDeleteButtonProps = {
  workspaceId: string
  botId: string
  kbId: string
  knowledgeSourceIds: string[]
  webPageSourceIds?: string[]
  selectedKnowledgeSourcesCount: number
  onSuccess?: () => void
}

export const KnowledgeSourceDeleteButton = ({
  workspaceId,
  botId,
  kbId,
  knowledgeSourceIds,
  webPageSourceIds,
  selectedKnowledgeSourcesCount,
  onSuccess,
}: KnowledgeSourceDeleteButtonProps) => {
  const { mutateAsync: deleteKnowledgeSources, isPending } = useDeleteKnowledgeSources({ workspaceId, botId })

  const handleDeleteKnowledgeSources = async () => {
    await deleteKnowledgeSources(
      {
        workspaceId,
        botId,
        kbId,
        ids: knowledgeSourceIds,
        dsIds: webPageSourceIds || [],
      },
      {
        onSuccess: () => {
          onSuccess?.()
        },
      }
    )
  }

  return (
    <Button
      variant="outline"
      disabled={isPending}
      onClick={() => {
        showConfirmationPrompt('Are you sure you want to delete these knowledge sources ?', {
          title: 'Delete Knowledge Sources',
          variant: 'danger',
        }).then(() => handleDeleteKnowledgeSources())
      }}
    >
      <Trash color="red" />
      {isPending ? 'Deleting...' : `${selectedKnowledgeSourcesCount} Selected`}
    </Button>
  )
}
